import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/app/duty-scheduling")({
  component: Outlet,
  beforeLoad: ({ context: { t, permittedRoutes } }) => {
    if (
      permittedRoutes.find((x) => {
        return x.route === Route.fullPath
      })
    ) {
      return {
        getTitle: () => t("DutyScheduling"),
      }
    }
  },
})
